import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API from "../../services/api";
import toast from "react-hot-toast";

function EditPermission() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const [form, setForm] = useState({
    module_name: "",
    permission_key: "",
    permission_name: "",
  });

  useEffect(() => {
    loadPermission();
  }, []);

  const loadPermission = async () => {
    try {
      const res = await API.get(
        `/permissions/single/${id}`
      );

      setForm({
        module_name:
          res.data.module_name || "",
        permission_key:
          res.data.permission_key || "",
        permission_name:
          res.data.permission_name || "",
      });

    } catch (err) {
      console.log(err);
      toast.error(
        "Failed to load permission"
      );
    } finally {
      setPageLoading(false);
    }
  };

  const submit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await API.put(
        `/permissions/${id}`,
        form
      );

      toast.success(
        "Permission updated successfully"
      );

      navigate(
        "/admin/permissions"
      );

    } catch (err) {
      console.log(err);

      toast.error(
        err.response?.data?.message ||
          "Update failed"
      );
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <div
        className="
        flex
        justify-center
        items-center
        h-[400px]
        text-xl
        "
      >
        Loading...
      </div>
    );
  }

  return (
    <div>

      <div className="mb-8">

        <h1
          className="
          text-4xl
          font-bold
          "
        >
          Edit Permission
        </h1>

        <p
          className="
          text-gray-400
          mt-2
          "
        >
          Update permission information
        </p>

      </div>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        border
        border-yellow-500/20
        rounded-2xl
        p-8
        max-w-3xl
        "
      >

        <div className="mb-6">

          <label
            className="
            block
            mb-2
            font-semibold
            "
          >
            Module Name
          </label>

          <input
            type="text"
            required
            value={form.module_name}
            onChange={(e) =>
              setForm({
                ...form,
                module_name:
                  e.target.value,
              })
            }
            className="
            w-full
            bg-black
            border
            border-yellow-500/20
            rounded-xl
            p-3
            outline-none
            focus:border-yellow-500
            "
          />

        </div>

        <div className="mb-6">

          <label
            className="
            block
            mb-2
            font-semibold
            "
          >
            Permission Key
          </label>

          <input
            type="text"
            required
            value={form.permission_key}
            onChange={(e) =>
              setForm({
                ...form,
                permission_key:
                  e.target.value,
              })
            }
            className="
            w-full
            bg-black
            border
            border-yellow-500/20
            rounded-xl
            p-3
            outline-none
            focus:border-yellow-500
            "
          />

          <p
            className="
            text-xs
            text-gray-500
            mt-2
            "
          >
            Example:
            product.view,
            product.add,
            product.edit,
            product.delete
          </p>

        </div>

        <div className="mb-8">

          <label
            className="
            block
            mb-2
            font-semibold
            "
          >
            Permission Name
          </label>

          <input
            type="text"
            required
            value={form.permission_name}
            onChange={(e) =>
              setForm({
                ...form,
                permission_name:
                  e.target.value,
              })
            }
            className="
            w-full
            bg-black
            border
            border-yellow-500/20
            rounded-xl
            p-3
            outline-none
            focus:border-yellow-500
            "
          />

        </div>

        <div
          className="
          flex
          gap-4
          "
        >

          <button
            type="submit"
            disabled={loading}
            className="
            bg-yellow-500
            hover:bg-yellow-400
            text-black
            font-semibold
            px-8
            py-3
            rounded-xl
            disabled:opacity-50
            "
          >
            {loading
              ? "Updating..."
              : "Update Permission"}
          </button>

          <button
            type="button"
            onClick={() =>
              navigate(
                "/admin/permissions"
              )
            }
            className="
            bg-gray-700
            hover:bg-gray-600
            px-8
            py-3
            rounded-xl
            "
          >
            Cancel
          </button>

        </div>

      </form>

    </div>
  );
}

export default EditPermission;